import React, { useState } from 'react'
import Reveal from './Reveal'
import SectionHead from './SectionHead'
import { useTimeline } from '../i18n/hooks'
import { useI18n } from '../i18n/LanguageContext'

function Timeline() {
  const { t } = useI18n()
  const { items, filters } = useTimeline()
  const [filter, setFilter] = useState('all')
  const visible = filter === 'all' ? items : items.filter((item) => item.tag === filter)

  return (
    <section className="section" id="timeline" aria-labelledby="timeline-title">
      <div className="container">
        <SectionHead id="timeline-title" kicker={t.timeline.kicker} title={t.timeline.title} lead={t.timeline.lead} />
        <Reveal className="chips" role="group" aria-label={t.common.filterTimelineAria}>
          {filters.map((chip) => (
            <button
              key={chip.id}
              type="button"
              className={`chip${filter === chip.id ? ' is-active' : ''}`}
              aria-pressed={filter === chip.id}
              onClick={() => setFilter(chip.id)}
            >
              {chip.label}
            </button>
          ))}
        </Reveal>
        <ol className="timeline">
          {visible.map((item) => (
            <li key={item.id} className="timeline-item">
              <span className="timeline-dot" aria-hidden="true" />
              <div className="timeline-card">
                <p className="timeline-when">{item.when}</p>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
                <span className="timeline-tag">{filters.find((f) => f.id === item.tag)?.label}</span>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}

export default Timeline
